'use client';
import React from 'react';
import {useI18n} from '@udemy-v2/i18n';

import {TestimonialCard} from './testimonial-card';
import styles from './testimonials.module.scss';

const Testimonials = ({testimonials = []}) => {
    const {gettext} = useI18n();
    // If no testimonials are provided, use default data
    const defaultTestimonials = [
        {
            quote: gettext(
                'Udemy definitely helped me accomplish my goal of becoming a data scientist. And it has been awesome.',
            ),
            author: 'Tiffany T.',
            iconSrc: '/indeed/images/quote.svg',
        },
        {
            quote: gettext(
                'Without Udemy, I could not have gone from being an unemployed musician to a software engineer in under a year.',
            ),
            author: 'Evan T.',
            iconSrc: '/indeed/images/quote.svg',
        },
        {
            quote: gettext(
                'Udemy helped me pass my SHRM-SCP — Udemy is user friendly and is a great tool to use for your learning and career development … it helped me to pass my exam.',
            ),
            author: 'Rochelle T.',
            iconSrc: '/indeed/images/quote.svg',
        },
    ];

    const testimonialsToRender = testimonials.length > 0 ? testimonials : defaultTestimonials;

    return (
        <div className={styles.testimonialContainer}>
            <h1 className={styles.title}>
                {gettext('Learning turns job seekers into job winners')}
                <br />
            </h1>
            <div className={styles.testimonialSection}>
                {testimonialsToRender.map((testimonial, index) => (
                    <TestimonialCard
                        key={index}
                        quote={testimonial.quote}
                        author={testimonial.author}
                        iconSrc={testimonial.iconSrc}
                    />
                ))}
            </div>
        </div>
    );
};

export {Testimonials};
